<template>
    <div class="row">
        <div class="col-12 col-xl-5">
            <div class="c-careers__search">
                <h2>Search By</h2>
                <form action="" method="GET" @submit.prevent="runSearch">
                <div class="form-group row keywords-row">
                    <div class="col-12">
                        <input class="form-control" type="text" value="" id="keywords" v-model="terms.keywords" placeholder="Keywords" maxlength="100">
                    </div>
                </div>
                <div class="form-group row state-row">
                    <div class="col-12">
                        <select class="form-control" id="state" v-model="terms.state" @change="terms.city = ''">
                            <option value="">State</option>
                            <option v-for="state in availableStates">{{ state }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row city-row" v-if="terms.state">
                    <div class="col-12">
                        <select class="form-control" id="city" v-model="terms.city">
                            <option value="">City</option>
                            <option v-for="city in availableCities">{{ city }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row practice-row">
                    <div class="col-12">
                        <select class="form-control" id="practice" v-model="terms.practice">
                            <option value="">All Practices</option>
                            <option v-for="practice in availablePractices">{{ practice }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row jobType-row">
                    <div class="col-12">
                        <div class="form-check form-check-inline">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" value="Full-Time" id="fulltime" v-model="terms.jobType">
                                <label for="fulltime">Full Time</label>
                            </label>
                        </div>
                        <div class="form-check form-check-inline">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" value="Part-Time" id="parttime" v-model="terms.jobType">
                                <label for="parttime">Part Time</label>
                            </label>
                        </div>
                        <div class="form-check form-check-inline">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" value="Internship" id="internship" v-model="terms.jobType">
                                <label for="internship">Internships</label>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group row submit-row">
                    <div class="col-12">
                        <input class="btn-main" type="submit" value="Search" id="searchJobs">
                    </div>
                </div>
                </form>
            </div>
        </div>
        <div class="col-12 col-xl-6">
            <div class="c-careers__inner" v-if="loaded">
                <div class="careers-current-page">
                    <span v-if="openings[0].length">
                        Showing {{ currentPage * postsPerPage + 1 }} - {{ currentPage * postsPerPage + openings[currentPage].length }} of {{ totalResults }} Results <span v-if="!!termlist">for <strong>{{ termlist }}</strong></span>
                    </span>
                    <span v-else>
                        No results found <span v-if="!!termlist">for {{ termlist }}</span>
                    </span>
                </div>
                <div class="careers-results" v-if="openings[0].length">
                    <ul class="featured-positions">
                        <li class="position" v-for="position in openings[currentPage]">
                            <div class="position__inner">
                                <div class="details">
                                    <h4>{{ position.Title }}</h4>
                                    <ul class="position__locations">
                                        <li class="location" :class="{ 'location--primary': location.Primary }" v-for="location in sortedLocations(position.Locations)">
                                            <p v-if="location.City !== 'United States'">
                                                <span v-if="location.City">{{ location.City }} </span>
                                                <span v-if="location.State">{{ stateToAbbr(location.State) }}, </span>
                                                <span v-if="location.Country">{{ countryToAbbr(location.Country) }}</span>
                                            </p>
                                            <p v-else>Nationwide</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="cta">
                                    <a :href="`/careers/${position.RequisitionNumber}`" class="btn-main">VIEW</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="careers-pagination" v-if="openings.length > 1">
                    <a href="#" v-for="(chunk, index) in openings" @click.prevent="updatePage(index)">{{ index + 1 }}</a>
                </div>
            </div>
            <div class="c-careers__inner" v-else>
                LOADING....
            </div>
        </div>
    </div>
</template>

<script>
    import { utils } from '../../Util';
    const $ = jQuery;
    
    export default {
        name: "careers",
        props: {
            api: String,
            originalSource: {
                type: String,
                default: "Careers Search"
            },
            keywords: {
                type: String,
                default: ""
            },
            city: {
                type: String,
                default: ""
            },
            state: {
                type: String,
                default: ""
            },
            practice: {
                type: String,
                default: ""
            },
            postsPerPage: {
                type: Number,
                default: 50,
            }
        },
        data: function () {
            return {
                allOpenings: [],
                openings: [[]],
                currentPage: 0,
                loaded: false,
                source: false,
                totalResults: 0,
                availableLocations: {},
                availablePractices: [
                    'Architecture',
                    'Aviation',
                    'Bridge',
                    'Cold Regions Engineering',
                    'Construction Services',
                    'Corporate',
                    'Cost Management',
                    'Design-Build',
                    'Energy',
                    'Environmental',
                    'Federal',
                    'Geospatial',
                    'Intelligent Transportation',
                    'IT',
                    'Land Development',
                    'Planning',
                    'Rail & Transit',
                    'Technology',
                    'Transportation/Highway',
                    'Water',
                ],
                terms: {
                    keywords: this.keywords,
                    city: this.city,
                    state: this.state,
                    practice: this.practice,
                    jobType: []
                },
                termlist: '',
            };
        },
        computed: {
            searching: function () {
                let isSearching = false;
                $.each(this.terms, (i, v) => {
                    if (!!(Array.isArray(v) ? v.length : v)) {
                        isSearching = true;
                        return false;
                    }
                    return true;
                });
                return isSearching;
            },
            availableStates: function () {
                return Object.keys(this.availableLocations).filter(k => !!k && k !== 'United States').sort();
            },
            availableCities: function () {
                if (this.availableLocations.hasOwnProperty(this.terms.state)) {
                    return this.availableLocations[this.terms.state].filter(k => !!k && k !== 'United States').sort();
                }
                return [];
            }
        },
        mounted() {
            let doSearch = false;
            ['keywords', 'practice', 'city', 'state'].forEach((p) => {
                if (this.terms[p]) {
                    doSearch = true;
                }
            });
            
            $.ajax({
                dataType: "json",
                url: this.api,
                success: (data) => {
                    this.allOpenings = data.Entities;
                    this.totalResults = data.TotalEntities;
                    this.openings = utils.array.chunk(this.allOpenings, this.postsPerPage);
                    this.availableLocations = data.AvailableLocations;
                    this.loaded = true;
                    
                    if (doSearch) {
                        this.runSearch();
                        this.resetInvalidTerms();
                    }
                }
            });
        },
        /*watch: { // This is how we can make the search reactive without clicking the submit button
            terms: {
                handler(val) {
                    this.runSearch();
                },
                deep: true,
            }
        },*/
        methods: {
            stateToAbbr: utils.abbr.stateToAbbr,
            countryToAbbr: utils.abbr.countryToAbbr,
            sortedLocations(locations) {
                return utils.array.clone(locations).sort(utils.sorts.sortLocation);
            },
            updatePage: function (i) {
                this.currentPage = i;
                console.log(this.currentPage, this.openings[this.currentPage]);
            },
            runSearch: function () {
                this.currentPage = 0;
                this.termlist = [this.terms.keywords, this.terms.city, this.terms.state, this.terms.practice, this.terms.jobType.join(', ')].filter((term) => {
                    return !!term;
                }).join(', ');

                let results = this.allOpenings;
                if (this.searching) {
                    results = this.find();
                }
                this.openings = utils.array.chunk(results, this.postsPerPage);

                this.totalResults = results.length;

                this.$nextTick(() => {
                    if ($(window).width() <= 1199) {
                        const scrollPos = $(".careers-current-page").offset().top - 130;
                        $(window).scrollTop(scrollPos);
                    }
                });
                const termList = [
                    this.terms.city || 'No City Entered',
                    this.terms.state || 'No State Entered',
                    this.terms.practice || 'No Practice Entered',
                    this.terms.jobType.join(', ') || 'No Job Types Selected',
                ].join(', ');
                GTM.fire(
                    'mbiEvent',
                    `Careers Search - ${this.source || this.originalSource}`,
                    `${termList}`,
                    `${this.terms.keywords || 'No Keywords entered'}`
                );

                this.source = 'Careers Search Page';
            },
            find: function () {
                return this.allOpenings.filter((item) => {
                    let keywordMatch = true;
                    let cityMatch = true;
                    let stateMatch = true;
                    let practiceMatch = true;
                    let jobTypeMatch = true;

                    const isTermMatch = (term, property) => {
                        return new RegExp(`${term}`, 'gi').test(property);
                    };

                    if (this.terms.keywords) {
                        keywordMatch = !!this.terms.keywords.split(' ').filter(value => {
                            return isTermMatch(value, item.Title)
                                || isTermMatch(value, item.ContestNumber)
                                || isTermMatch(value, item.Practice)
                                || isTermMatch(value, item.JobType)
                                || item.Locations.some((loc) => isTermMatch(value, loc.City)
                                    || isTermMatch(value, loc.State)
                                    || isTermMatch(value, loc.Country));
                        }).length;
                    }

                    if (this.terms.city) {
                        cityMatch = item.Locations.some((loc) => {
                            return !loc.City || loc.City === 'United States' || isTermMatch(this.terms.city, loc.City);
                        });
                    }
                    if (this.terms.state) {
                        stateMatch = item.Locations.some((loc) => {
                            return !loc.State || loc.State === 'United States' || isTermMatch(this.terms.state, loc.State);
                        });
                    }
                    if (this.terms.practice) {
                        practiceMatch = this.terms.practice.toLowerCase() === item.Practice.toLowerCase();
                    }
                    if (this.terms.jobType.length) {
                        jobTypeMatch = !!this.terms.jobType.filter(value => isTermMatch(value, item.JobType)).length;
                    }
                    return keywordMatch && cityMatch && stateMatch && practiceMatch && jobTypeMatch;
                });                
            },
            resetInvalidTerms: function () {
                if (this.terms.practice && this.availablePractices.indexOf(this.terms.practice) === -1) {
                    this.terms.practice = '';
                }
                if (this.terms.state && this.availableStates.indexOf(this.terms.state) === -1) {
                    this.terms.state = '';
                }
                if (this.terms.city && this.availableCities.indexOf(this.terms.city) === -1) {
                    this.terms.city = '';
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// Assets/Scripts/Components/Careers/search.vue